import React, { useState } from 'react';
import { Listbox } from '@headlessui/react';
import emailjs from '@emailjs/browser';

// Initialize EmailJS with your user ID
emailjs.init('wLZvOQBgnH2k5Fegq');

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    vorname: '',
    selection: '',
    note: '',
    telephone: '',
    email: ''
  });

  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const options = [
    { value: '', name: 'Bitte wählen...', disabled: true },
    { value: 'option1', name: 'Photovoltaik' },
    { value: 'option2', name: 'Wärmepumpe' },
    { value: 'option3', name: 'Energieberatung' },
  ];

  const isValidPhoneNumber = (number) => {
    const phoneRegex = /^\+?[0-9]{7,15}$/;
    return phoneRegex.test(number);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    // Validation checks
    if (!formData.name.trim() || !formData.vorname.trim()) {
      setError('Nachname und Vorname sind erforderlich.');
      setIsSubmitting(false);
      return;
    }

    if (!formData.selection) {
      setError('Bitte wählen Sie ein Thema aus.');
      setIsSubmitting(false);
      return;
    }

    if (!formData.email.trim() && !formData.telephone.trim()) {
      setError('Bitte geben Sie entweder eine Telefonnummer oder eine E-Mail-Adresse an.');
      setIsSubmitting(false);
      return;
    }

    if (formData.telephone.trim() && !isValidPhoneNumber(formData.telephone)) {
      setError('Bitte geben Sie eine gültige Telefonnummer ein.');
      setIsSubmitting(false);
      return;
    }

    if (formData.email.trim() && !isValidEmail(formData.email)) {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      setIsSubmitting(false);
      return;
    }

    try {
      // Construct the message body
      const selectedOption = options.find(opt => opt.value === formData.selection);
      const messageBody = `
        Neue Kontaktanfrage:
        --------------------
        Vorname: ${formData.vorname}
        Nachname: ${formData.name}
        Thema: ${selectedOption?.name || ''}
        Telefon: ${formData.telephone}
        Email: ${formData.email}
        Notiz:
        ${formData.note}
      `;

      // Send email using EmailJS
      await emailjs.send(
        'service_g5pc0cn',
        'template_hbpsnb4',
        { message: messageBody }
      );

      // Reset form on success
      setFormData({
        name: '',
        vorname: '',
        selection: '',
        note: '',
        telephone: '',
        email: ''
      });

      alert('Nachricht erfolgreich gesendet!');
    } catch (error) {
      setError('Beim Senden der Nachricht ist ein Fehler aufgetreten.');
      console.error('Error sending email:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-6">
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && <p className="text-red-600 text-sm font-medium">{error}</p>}

        <div className="grid grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-sm font-medium text-secondary-dark" htmlFor="vorname">
              Vorname
            </label>
            <input
              type="text"
              id="vorname"
              name="vorname"
              value={formData.vorname}
              onChange={handleChange}
              className="mt-2 block w-full p-3 border border-secondary-dark rounded-md focus:ring-primary focus:border-primary"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-secondary-dark" htmlFor="name">
              Nachname
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-2 block w-full p-3 border border-secondary-dark rounded-md focus:ring-primary focus:border-primary"
              required
            />
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-secondary-dark" htmlFor="selection">
            Thema
          </label>
          <Listbox 
            value={formData.selection} 
            onChange={(value) => setFormData({...formData, selection: value})}
          >
            <div className="relative mt-2">
              <Listbox.Button className="w-full p-3 text-left bg-white border border-secondary-dark rounded-md focus:ring-primary focus:border-primary text-lg cursor-pointer">
                <span className="block truncate">
                  {options.find(opt => opt.value === formData.selection)?.name || 'Bitte wählen...'}
                </span>
                <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                    />
                  </svg>
                </span>
              </Listbox.Button>
              <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                {options.map((option) => (
                  <Listbox.Option
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                    className={({ active }) =>
                      `cursor-default select-none relative p-3 ${
                        active ? 'bg-primary text-white' : 'text-gray-900'
                      } ${option.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`
                    }
                  >
                    {({ selected }) => (
                      <span
                        className={`block truncate ${
                          selected ? 'font-medium' : 'font-normal'
                        }`}
                      >
                        {option.name}
                      </span>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </div>
          </Listbox>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-secondary-dark" htmlFor="note">
            Notiz
          </label>
          <textarea
            id="note"
            name="note"
            value={formData.note}
            onChange={handleChange}
            className="mt-2 block w-full p-3 border border-secondary-dark rounded-md focus:ring-primary focus:border-primary"
            rows="4"
          />
        </div>

        <div className="grid grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-sm font-medium text-secondary-dark" htmlFor="telephone">
              Telefon
            </label>
            <input
              type="tel"
              id="telephone"
              name="telephone"
              value={formData.telephone}
              onChange={handleChange}
              className="mt-2 block w-full p-3 border border-secondary-dark rounded-md focus:ring-primary focus:border-primary"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-secondary-dark" htmlFor="email">
              E-Mail
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="mt-2 block w-full p-3 border border-secondary-dark rounded-md focus:ring-primary focus:border-primary"
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-primary text-secondary-light p-3 rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? 'Sende...' : 'Absenden'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;